import { fmtNum, fmtPct, cleanNum } from "@/lib/format";

const SECTIONS = [
  { key: "footage", title: "Work Inspected / Operation", unit: "ft" },
  { key: "welding", title: "Welding", unit: "" },
  { key: "ndt", title: "NDT", unit: "" },
];

export default function FootageInputs({ items, values, previous, totalFootage, onChange, errors, template }) {
  const facility = template === "facility";
  return (
    <div className="space-y-5">
      {SECTIONS.map((s) => {
        const rows = items.filter((i) => i.section === s.key);
        if (!rows.length) return null;
        return (
          <div key={s.key} data-testid={`footage-section-${s.key}`}>
            <p className={`mb-2 px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-slate-900 ${facility ? "bg-[#C0C0C0]" : "bg-[#FAC090]"}`}>{s.title}</p>
            <div className="divide-y divide-border rounded-md border border-border">
              {rows.map((i) => {
                const today = Number(values[i.key] || 0);
                const prev = Number(previous[i.key] || 0);
                const total = today + prev;
                const est = Number(i.estimate || 0);
                const pct = facility && i.section === "footage" ? (est ? total / est : null) : (i.percent && est ? total / est : i.percent && totalFootage ? total / totalFootage : null);
                const err = errors?.[`line_values.${i.key}`];
                const calc = facility && i.section === "footage"
                  ? `${i.unit ? `${i.unit} · ` : ""}Total ${fmtNum(total)}${est ? ` of ${fmtNum(est)} · ${fmtPct(pct)}` : " · Est. TBD"}`
                  : `Prev ${fmtNum(prev)} · Total ${fmtNum(total)}${i.section === "footage" ? ` · ${i.percent ? `${est ? `of ${fmtNum(est)} ft · ` : ""}${fmtPct(pct)}` : "N/A"}` : ""}`;
                return (
                  <div key={i.key} className="flex items-center gap-3 px-3 py-2">
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-semibold leading-tight text-slate-900">{i.label}</p>
                      <p className="font-mono-num mt-0.5 text-[11px] text-slate-500" data-testid={`line-calc-${i.key}`}>{calc}</p>
                      {err && <p className="text-xs text-red-600">{err}</p>}
                    </div>
                    <input type="text" inputMode="decimal" autoComplete="off" placeholder="0"
                      value={values[i.key] ?? ""} onChange={(e) => onChange(i.key, cleanNum(e.target.value))}
                      className="font-mono-num h-12 w-24 shrink-0 rounded-md border border-input bg-white px-2 text-right text-lg font-semibold focus:border-[#5C241E] focus:outline-none focus:ring-2 focus:ring-[#5C241E]/20 sm:w-32"
                      data-testid={`line-input-${i.key}`} aria-label={`${i.label} today`} />
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
